import { Check } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { TAGLINE } from "@/data/site";

export const EquestrianSection = ({ e }) => (
  <section data-testid="equestrian-section" className="bg-[#14263D] py-20 text-white md:py-28">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 md:px-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#f0b3b7]">{e.eyebrow}</p>
        <h2 data-testid="equestrian-title" className="mt-4 font-display text-4xl font-semibold leading-tight md:text-5xl">{e.title}</h2>
        {e.paras.map((p) => <p key={p} className="mt-6 text-base leading-relaxed text-white/85 md:text-lg">{p}</p>)}
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8">
        <p className="text-base font-medium text-white">{e.listIntro}</p>
        <ul data-testid="equestrian-communities" className="mt-5 border-t border-white/15">
          {e.communities.map((c) => (
            <li key={c} className="flex gap-3 border-b border-white/15 py-4 text-base"><Check className="mt-1 h-4 w-4 shrink-0 text-[#f0b3b7]" />{c}</li>
          ))}
        </ul>
        <p className="mt-6 text-base leading-relaxed text-white/85">{e.closing}</p>
        <p className="mt-6 font-display text-2xl italic text-white">{TAGLINE}</p>
        <p data-testid="equestrian-scope" className="mt-6 text-sm leading-relaxed text-white/75">{e.scope}</p>
      </Reveal>
    </div>
  </section>
);
